import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ContentSelected } from './styled';

const CountrySelectWithNumbersCustom = ({ onChange, fieldMobile, disabled = false }) => {
  const handlePhoneChange = (value, data) => {
    onChange({ code: data.dialCode, mobile: value.substring(data.dialCode.length), fullNumber: value });
  };

  return (
    <ContentSelected>
      <PhoneInput
        country="co"
        value={`${fieldMobile?.code}${fieldMobile?.mobile}`}
        onChange={handlePhoneChange}
        inputStyle={{ width: '100%' }}
        enableSearch
        disableSearchIcon
        disabled={disabled}
      />
    </ContentSelected>
  );
};

export default CountrySelectWithNumbersCustom;

CountrySelectWithNumbersCustom.propTypes = {
  onChange: PropTypes.func,
  fieldMobile: PropTypes.object,
  disabled: PropTypes.bool,
};
